import {Component, Input, OnInit, ViewEncapsulation, Renderer2} from '@angular/core';
import {Observable} from 'rxjs';
import {ConsoleAuthenticationService} from "@security/console-authentication.service";

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class AppComponent implements OnInit {
  public loggedIn!: Observable<boolean>;
  title = 'soko-console-web';
  @Input() public forgotPassword: boolean;

  constructor(private authService: ConsoleAuthenticationService, private renderer: Renderer2) {
      this.forgotPassword = false;
  }

  ngOnInit(): void {
    this.loggedIn = this.authService.isLoggedIn;
  }
}
